import {Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, OnInit} from '@angular/core';
import {DcpApiService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {I18nModule, PaymentDetails} from '@spartacus/core';
import {ActiveCartService} from '@spartacus/cart/base/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {first, switchMap, take} from 'rxjs';

import {AutofocusDirective} from '../../../../directives/autofocus/autofocus.directive';

@UntilDestroy()
@Component({
  selector: 'dcp-remove-credit-card-dialog',
  imports: [I18nModule, AutofocusDirective],
  templateUrl: './remove-credit-card-dialog.component.html',
  styleUrl: './remove-credit-card-dialog.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RemoveCreditCardDialogComponent implements OnInit {
  creditCardData: PaymentDetails;
  last4Digits: string;
  cardBrand: string;
  inProgress = false;

  @HostListener('document:keydown.escape')
  @HostListener('click')
  handleClickOrEsc(): void {
    this.launchDialogService.closeDialog('Cancel');
  }

  constructor(
    public launchDialogService: LaunchDialogService,
    private apiService: DcpApiService,
    private activeCartService: ActiveCartService,
  ) {}

  ngOnInit(): void {
    this.launchDialogService.data$.pipe(first(), untilDestroyed(this)).subscribe((data) => {
      this.creditCardData = data.creditCardData;
      this.last4Digits = this.creditCardData?.cardNumber?.slice(-4);
      this.cardBrand = this.creditCardData?.cardType?.name;
    });
  }

  removeCreditCard(creditCardData: PaymentDetails) {
    this.inProgress = true;

    this.activeCartService
      .getActive()
      .pipe(
        take(1),
        switchMap((cart) =>
          this.apiService.callKyma(
            'cardExport',
            'paymentDetails',
            {paymentDetailsId: creditCardData.id, cartId: cart.code},
            {},
            'DELETE',
          ),
        ),
        untilDestroyed(this),
      )
      .subscribe({
        next: (result) => {
          this.launchDialogService.closeDialog({paymentDetailsId: creditCardData.id});
        },
        error: (error) => {
          this.launchDialogService.closeDialog({error});
        },
      });
  }
}
